export const CANNY_APP_ID = '624f210921b1f7528dab3be1';
export const CANNY_DEAL_LABEL_ID = '67a2768f9ff5d23c02763e1a';
